import React from 'react';
import { connect } from 'react-redux';
import uniqid from 'uniqid';

import { change } from 'store/root/actions';
import { useStateSelector } from 'utils/field';

import Tooltip from 'components/Tooltip';

import classes from './style.module.scss';

import { LockClosed, LockOpen } from 'assets/images/icons/JSX/Lock';

const LockTooltip = ({ lockNotice, className, name, change }) => {
    const id = uniqid("tooltip-");

    const isLocked = useStateSelector(`${name}_lock`) ?? true;
    
    const handleClick = () => {
        change(`${name}_lock`, !isLocked);
    }

    return (
        <div
            className={`${classes.lockNotice} ${className && className}`}
            data-html
            data-tip={`<span style="display:block;max-width:14rem;">${lockNotice}</span>`}
            data-for={`${id}_lockNoticeTip`}
            onClick={handleClick}
        >
            {isLocked ? <LockClosed /> : <LockOpen />}
            <Tooltip id={`${id}_lockNoticeTip`} />
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
    change: (path, value) => dispatch(change(path, value)),
});

export default connect(null, mapDispatchToProps)(LockTooltip);